'use strict';

/* globals config, $, socket */

require([
	config.relative_path + '/plugins/nodebb-plugin-courses/static/vendor/vue.js',
], function (Vue) {
	var internals = {};

	Vue.component('course-analytics-group-attempts', {
		props: ['initData', 'groupedAttempts', 'openUserAttempts'],
		data: function () {
			return {
				filterSearch: ''
			};
		},
		computed: {
			attempts: function () {
				if (this.filterSearch === '') {
					return this.groupedAttempts;
				}
				
				var searchText = this.filterSearch.toUpperCase();
				
				var results = [];
				for (var i = 0; i < this.groupedAttempts.length; i++) {
					if (this.groupedAttempts[i].user && this.groupedAttempts[i].user.username && this.groupedAttempts[i].user.username.toUpperCase().indexOf(searchText) !== -1) {
						results.push(this.groupedAttempts[i]);
					}
				}
				
				return results;
			}	
		},
		template:
		'<div>' +
			'<div class="row">' +
				'<div class="col-md-6 text-right">' +
					'Search by user: ' +
				'</div>' +
				'<div class="col-md-6">' +
					'<input type="text" v-model="filterSearch" class="form-control" >' +
				'</div>' +
			'</div>' +
			'<div class="row mt-4">' +
				'<table class="table table-bordered table-hover">' +
					'<thead>' +
						'<th>{{initData.translations.courseAnalyticsUsername}}</th>' +
						'<th>{{initData.translations.courseAnalyticsLastAttempt}}</th>' +
						'<th>{{initData.translations.courseAnalyticsAttemptsCount}}</th>' +
					'</thead>' +
					'<tbody>' +
						'<tr v-for="attempt in attempts" v-on:click="openUserAttempts(attempt)">' +
							'<td>{{attempt.user.username}}</td>' +
							'<td>{{attempt.lastAttempt}}</td>' +
							'<td>{{attempt.attemptsCount}}</td>' +
						'</tr>' +
					'</tbody>' +
				'</table>' +
			'</div>' +
		'</div>',
	});
});
